/**
 * Convert date filter values to actual date ranges
 * Returns object with start_date and end_date in YYYY-MM-DD format
 */

export const getDateRangeFromFilter = (filterValue) => {
  const today = new Date();
  const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
  const endOfToday = new Date(today.getFullYear(), today.getMonth(), today.getDate());

  // Handle custom date range
  if (filterValue && typeof filterValue === 'object' && filterValue.start && filterValue.end) {
    return {
      start_date: filterValue.start,
      end_date: filterValue.end,
    };
  }

  // Handle string filter labels
  const filter = filterValue || "Last 3 months";

  switch (filter) {
    case "This week": {
      // Last 7 days including today
      const weekStart = new Date(today);
      weekStart.setDate(today.getDate() - 6);
      return {
        start_date: formatDate(weekStart),
        end_date: formatDate(today),
      };
    }

    case "This month": {
      // From 1st of current month to today
      return {
        start_date: formatDate(startOfMonth),
        end_date: formatDate(today),
      };
    }

    case "Last 3 months": {
      // Last 90 days
      const threeMonthsAgo = new Date(today);
      threeMonthsAgo.setDate(today.getDate() - 89);
      return {
        start_date: formatDate(threeMonthsAgo),
        end_date: formatDate(today),
      };
    }

    default:
      // Default to current month
      return {
        start_date: formatDate(startOfMonth),
        end_date: formatDate(today),
      };
  }
};

/**
 * Format date to YYYY-MM-DD string
 */
const formatDate = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

